import { Options, Vue } from 'vue-class-component';

import List from '@/pages/contact/list/list.vue';

@Options({
  name: 'contact',
  components: {
    'page-list': List,
  },
})
export default class Contact extends Vue {
  public isIndexOnly() {
    return /^[/]?contact[/]?$/.test(this.$router.currentRoute.value.path);
  }
}
